import React from "react";
import PropTypes from "prop-types";

const AcceptCancel = ({ user, scheduleModifyAccess, request, alreadyAccepted, onAction }) =>
  request.active && !alreadyAccepted ? (
    <div>
      {request.user_id !== user.id ? (
        <a
          href="#"
          className="btn btn-pink btn-raised btn-block"
          name="accept"
          onClick={onAction}
        >
          ACCEPT
        </a>
      ) : null}

      {scheduleModifyAccess || request.user_id === user.id ? (
        <a
          href="#"
          className="btn btn-indigo btn-raised btn-block"
          name="destroy"
          onClick={onAction}
        >
          CANCEL
        </a>
      ) : null}
    </div>
  ) : null;

const ApproveDeny = ({ user, scheduleModifyAccess, request, onAction }) =>
  !request.active && !request.processed && scheduleModifyAccess ? (
    <div>
      <a
        href="#"
        className="btn btn-pink btn-raised btn-block"
        name="approve"
        onClick={onAction}
      >
        APPROVE
      </a>
      <a
        href="#"
        className="btn btn-indigo btn-raised btn-block"
        name="deny"
        onClick={onAction}
      >
        DENY AND CREATE NEW SUB REQUEST
      </a>
    </div>
  ) : null;

const ReturnToManagement = ({ user, scheduleModifyAccess, request, onAction }) =>
  !request.active && request.processed && scheduleModifyAccess ? (
    <a
      href="#"
      className="btn btn-pink btn-block"
      name="returnToManagement"
      onClick={onAction}
    >
      RETURN TO MANAGEMENT
    </a>
  ) : null;

AcceptCancel.propTypes = {
  user: PropTypes.object.isRequired,
  request: PropTypes.object.isRequired,
  alreadyAccepted: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired
};

ApproveDeny.propTypes = {
  user: PropTypes.object.isRequired,
  request: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired
};

ReturnToManagement.propTypes = {
  user: PropTypes.object.isRequired,
  request: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired
};

export { AcceptCancel, ApproveDeny, ReturnToManagement };
